export const SCHOOL_IMPORT_AUDIT_SCHEMA = "School Import Audit";

const LOCAL_AUDIT_STORAGE_KEY = "karuna_school_import_audit_v1";

export interface SchoolImportAuditRecord {
  import_batch_id: string;
  row_number: number;
  action: "created" | "updated";
  record_id?: string;
  created_at: string;
  source_file?: string;
  persisted_to?: "database" | "local";
}

function readLocalAuditRecords(): SchoolImportAuditRecord[] {
  try {
    const raw = localStorage.getItem(LOCAL_AUDIT_STORAGE_KEY);
    if (!raw) {
      return [];
    }
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeLocalAuditRecords(records: SchoolImportAuditRecord[]) {
  try {
    localStorage.setItem(LOCAL_AUDIT_STORAGE_KEY, JSON.stringify(records));
  } catch {
    // ignore quota errors
  }
}

export async function persistSchoolImportAuditRecord(
  record: SchoolImportAuditRecord
): Promise<SchoolImportAuditRecord> {
  const localRecords = readLocalAuditRecords();
  localRecords.push({ ...record, persisted_to: "local" });
  writeLocalAuditRecords(localRecords.slice(-50000));
  return { ...record, persisted_to: "local" };
}

export function getLocalImportAuditRecords(
  importBatchId?: string
): SchoolImportAuditRecord[] {
  const records = readLocalAuditRecords();
  if (!importBatchId) {
    return records;
  }
  return records.filter(r => r.import_batch_id === importBatchId);
}

export function getImportAuditStorageInfo(): {
  total_local_records: number;
  schema_name: string;
} {
  return {
    total_local_records: readLocalAuditRecords().length,
    schema_name: SCHOOL_IMPORT_AUDIT_SCHEMA,
  };
}
